// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stack from "./Stack.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function StackFields(props) {
  return JsxRuntime.jsx(Stack.make, {
    children: props.children,
    space: "large"
  });
}

let make = StackFields;

export {
  make,
}
/* Stack Not a pure module */
